import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { wxCopilotContextManager } from '@/utils/wx-copilot-context-manager';

export function useWxCopilotPageContext(mountId = 'wx-copilot-root') {
  const location = useLocation();

  useEffect(() => {
    const url = `${location.pathname}${location.search}${location.hash}`;
    wxCopilotContextManager.sendPageContext(url, mountId);
  }, [location, mountId]);

  useEffect(() => {
    return () => {
      wxCopilotContextManager.cleanup();
    };
  }, []);
}
